import { secondaryProductsApiConnector } from 'apiConnector/secondary-market/product-search/searchProductsByCode';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import {
  secondaryMarketProductsSearchedCodesSaveFailed,
  secondaryMarketProductsSearchedKeysSaved,
} from 'state/secondaryMarket/productSearch';
import type { EpicWithThunk } from 'state/state.common';

export function saveSearchedCodes(): EpicWithThunk {
  return (
    actions$,
    state$,
    {
      httpClient,
      selectors: {
        fromSecondaryMarket: {
          productSearch: { getSecondaryMarketRowIds, getSecondaryMarketDlpRowIds },
        },
      },
    },
  ) => {
    const { saveRecentSearchKeys } = secondaryProductsApiConnector(httpClient);
    return actions$.pipe(
      ofType(
        'SECONDARY_MARKET_PRODUCT_CODE_SEARCH_RECEIVED',
        'SECONDARY_MARKET_PRODUCT_REMOVE_ITEM',
        'SECONDARY_MARKET_PRODUCT_CLEAR_ALL',
        'SECONDARY_MARKET_PRODUCT_CODE_SEARCH_CLEAR',
      ),
      withLatestFrom(state$),
      mergeMap(([_, state], __) => {
        const keys = getSecondaryMarketRowIds(state);
        const dlpKeys = getSecondaryMarketDlpRowIds(state);
        return saveRecentSearchKeys({ keys, dlpKeys }).pipe(
          map(_ => secondaryMarketProductsSearchedKeysSaved(keys)),
          catchError((err: Error) => of(secondaryMarketProductsSearchedCodesSaveFailed(err.message))),
        );
      }),
    );
  };
}
